import { catalystApi } from './http';

export async function launchThunder(playIds, appType, purpose, sheetName, authToken) {
  const response = await catalystApi.post('DASHBOARD/BuildThunderHyperUrl', {
    playIds,
    appType,
    name: ` ${purpose} - ${sheetName}`,
    authToken,
  });
  // eslint-disable-next-line no-console
  console.info('ThunderHyperURL: ', response.data.thunderHyperUrl);
  return response.data.thunderHyperUrl;
}
